<template>
    <v-stepper v-model="e13" vertical>
        <v-stepper-step step="1" :rules="[() => !!seoData]" :editable="!seoData" :complete="!!seoData">
            Upload CSV
            <small class="mt-2" v-if="!seoData">CSV Required</small>
        </v-stepper-step>

        <v-stepper-content step="1">
            <v-card flat>
                <v-card-text>
                    <v-file-input
                            v-model="files"
                            color="deep-purple accent-4"
                            counter
                            label="CSV File"
                            placeholder="Select your files"
                            prepend-icon="attach_file"
                            outlined
                            :success="!!files"
                            accept=".csv"
                            clearable
                            :display-size="1000">
                        <template v-slot:selection="{ index, text }">
                            <v-chip
                                    v-if="index < 2"
                                    color="deep-purple accent-4"
                                    dark
                                    label
                                    small>
                                {{ text }}
                            </v-chip>

                            <span
                                    v-else-if="index === 2"
                                    class="overline grey--text text--darken-3 mx-2">
                            +{{ files.length - 2 }} File(s)
                          </span>
                        </template>
                    </v-file-input>
                </v-card-text>
            </v-card>
            <v-btn color="primary" @click="startUpload(), e13 = 2">
                <v-icon left>cloud_upload</v-icon>
                Upload
            </v-btn>

        </v-stepper-content>

        <v-stepper-step step="2" editable>City Names & Variable</v-stepper-step>

        <v-stepper-content step="2">
            <v-card flat>

                <v-container>

                    <v-row>
                        <v-col cols="8">
                            <v-textarea
                                    required
                                    label="Cities"
                                    filled
                                    persistent-hint
                                    v-model="cities"
                                    hint="Separate with comma or new line"
                            >
                            </v-textarea>
                        </v-col>
                        <v-col cols="4">
                            <ul v-if="citiesList && citiesList.length > 0">
                                <li v-for="city in citiesList" :key="city">{{city}}</li>
                            </ul>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                    required
                                    filled
                                    label="Variable"
                                    placeholder="(CITY)"
                                    v-model="variableFormatting"
                            >

                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                    required
                                    filled
                                    label="ID Iterator"
                                    v-model="idIterator"
                            >

                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <div><small class="error--text" v-if="!checkItems">All items are required</small></div>
            <v-btn color="primary" :disabled="!checkItems" @click="e13 = 3,loopRows()">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step step="3">
            Download SEO
        </v-stepper-step>

        <v-stepper-content step="3">
            <v-card class="mb-12" flat>
                <v-card-text>
                    <v-btn color="primary" @click="downloadCSV()">
                        <v-icon left>cloud_download</v-icon>
                        Download
                    </v-btn>
                </v-card-text>
            </v-card>

        </v-stepper-content>

    </v-stepper>
</template>

<script>
	import Papa from 'papaparse';

	export default {
		data() {
			return {
				e13: 1,
				files: null,
				cities: [],
				variableFormatting: null,
				idIterator: 1,
				seoData: null,
				finalRows: []
			}
		},
		computed: {
			citiesList() {
				if (!this.cities || this.cities.length < 1) return null
				return this.cities.replace(/\n/g, ',').split(',').filter(e => e !== '').map(e => this.firstLetterUppercase(e.trim()))
			},
			checkItems() {
				return this.files && this.variableFormatting && this.idIterator && this.citiesList
			},
			variableEscaped() {
				let newvar = this.variableFormatting.replace(/(\()?(.*)(\))/g, "\\($2\\)")
				return newvar
			},
			variableForSlugAfter() {
				let newvar = this.variableFormatting.replace(/(\()?(.*)(\))/g, "(\\($2\\))(-)")
				return newvar
			},
			variableForSlugBefore() {
				let newvar = this.variableFormatting.replace(/(\()?(.*)(\))/g, "(-)(\\($2\\))")
				return newvar
			}
		},
		methods: {
			firstLetterUppercase(string) {
				return string.charAt(0).toUpperCase() + string.slice(1);
			},
			startUpload() {
				Papa.parse(this.files, {
					skipEmptyLines: 'greedy',
					header: true,
					complete: (results) => {
						this.seoData = results.data
					}
				})
			},
			loopRows() {
				this.finalRows = []
				window.localStorage.setItem('cities', this.cities)
				window.localStorage.setItem('variableFormatting', this.variableFormatting)
				window.localStorage.setItem('idIterator', this.idIterator)

				let re = new RegExp(this.variableEscaped, "gmi");
				let slugReBefore = new RegExp(this.variableForSlugBefore, "gmi")
				let slugReAfter = new RegExp(this.variableForSlugAfter, "gmi")
				// this.citiesList.forEach(city => {
				// 	this.finalRows.push(this.seoData.map(row => row.map(col => col.replace(re, city))))
				// })
				let nestedData = []
				this.citiesList.forEach(city => {
					nestedData.push(JSON.stringify(this.seoData).replace(slugReBefore, "$1" + city.toLowerCase()).replace(slugReAfter, city.toLowerCase() + "$2").replace(re, city))
				})

				nestedData = nestedData.map(row => JSON.parse(row))

				nestedData.map(data => {

					data.map(row => (row.id = this.idIterator++, this.finalRows.push(row)))
				})


			},
			downloadCSV() {
				let csv = Papa.unparse(this.finalRows);
				let csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
				let csvURL = null;
				if (navigator.msSaveBlob) {
					csvURL = navigator.msSaveBlob(csvData, 'download.csv');
				} else {
					csvURL = window.URL.createObjectURL(csvData);
				}

				let tempLink = document.createElement('a');
				tempLink.href = csvURL;
				tempLink.setAttribute('download', 'SEO.csv');
				tempLink.click();

			}
		},
		mounted() {
			window.localStorage.getItem('cities') && (this.cities = window.localStorage.getItem('cities'))
			window.localStorage.getItem('variableFormatting') && (this.variableFormatting = window.localStorage.getItem('variableFormatting'))
			window.localStorage.getItem('idIterator') && (this.idIterator = window.localStorage.getItem('idIterator'))
		}
	}
</script>
